
<div style="display:block; padding:8px 0px;" data-toggle="tooltip" title="">
  <div class="panel-header" (click)="onHeaderClick()">
    <i [ngClass]="(opened) ? 'fas fa-chevron-circle-up' : 'fas fa-chevron-circle-down'" style="width: 20px;" aria-hidden="true"></i>
    {{title | locale}}
  </div>
  <div class="panel-body" [ngStyle]="{'display':opened ? 'block' : 'none' }">
    <ng-content></ng-content>
  </div>
</div>